import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How long should I use it?',
  a: 'For best results, we recommend using the Zenify Neck Relief for 10-15 minutes per session, 1-2 times a day.'
}, {
  q: 'Is it safe?',
  a: "Yes! It is designed to provide gentle, controlled traction. You control the inflation level, ensuring it's always comfortable and safe for your specific needs."
}, {
  q: 'Does it really work?',
  a: 'Absolutely. By gently elevating the jawbone, it helps relieve tension in your neck and shoulders, improving posture and reducing pain caused by poor alignment.'
}, {
  q: 'Can I use it daily?',
  a: 'Yes, daily use is encouraged to maintain good posture and keep neck tension at bay, especially if you spend long hours at a desk or on your phone.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-gray-light py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-black" data-id="element-28">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-30">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex justify-between items-center p-6 text-left focus:outline-none" data-id="element-31">
                  <span className="text-lg font-bold text-brand-black" data-id="element-32">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-purple transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-33" />
                </button>
                <AnimatePresence data-id="element-34">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-35">
                      <div className="px-6 pb-6 text-brand-gray-dark leading-relaxed" data-id="element-36">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}